module.exports = __webpack_public_path__ + "img/28.6cd1abe6.png";